<template>
    <LoginScreen
            @login="login"
            @lostPassword="lostPassword"
            :loading="loading || $store.getters.getLoading"
            @setLanguage="setLanguage"
            :errors="$store.state.auth.loginErrors"
            class="bg-light"
    />
</template>

<script>
    import { LoginScreen } from "@tech_hexeko/design-system"
    import { store } from "../.."

    export default {
        data: function () {
            return {
                loading: false
            }
        },
        mounted() {
            if (this.$store.getters['auth/isLogged']) {
                let redirect = this.$route.query.redirect
                this.$router.push(redirect ? redirect : '/')
            }
        },
        methods: {
            login(credentials) {
                this.loading = true
                store.dispatch('auth/postLogin', {
                    email: credentials.email,
                    password: credentials.password,
                    redirect: this.$route.query.redirect
                }).then(() => {
                    this.loading = false
                })
            },
            lostPassword() {
                this.$router.push({ name: 'lost-password' })
            },
            setLanguage(lang) {
                store.dispatch('lang/setLanguage', lang)
            }
        },
        components: {
            LoginScreen
        }
    }
</script>